import type { DebugInfoReadoutItem } from '@/components/DebugInfoReadout';
import { atomWithStorage } from 'jotai/utils';

// Local storage atom for debug info visibility
export const debugInfoVisibleAtom = atomWithStorage(
  'uppbeat-debug-info-visible',
  false
);

// Jotai devtools panel visibility — off by default, toggled from the admin bar
export const jotaiDevtoolsVisibleAtom = atomWithStorage(
  'uppbeat-jotai-devtools-visible',
  false
);

export interface CarouselSearchDebugOverride {
  carouselDebugInfoVisible: boolean;
  overrideCarouselExcludes: string;
}

export const defaultOverrideCarouselSearchState = {
  carouselDebugInfoVisible: false,
  overrideCarouselExcludes: '',
};

export const OVERRIDE_CAROUSEL_SEARCH_STORAGE_KEY =
  'uppbeat-carousel-debug-override-search';

export const overrideCarouselSearchAtom =
  atomWithStorage<CarouselSearchDebugOverride>(
    OVERRIDE_CAROUSEL_SEARCH_STORAGE_KEY,
    defaultOverrideCarouselSearchState
  );

overrideCarouselSearchAtom.debugLabel = 'overrideCarouselSearchAtom';

export const CAROUSEL_DEBUG_READOUT_STORAGE_KEY =
  'uppbeat-carousel-debug-readout';

export const carouselDebugReadoutAtom = atomWithStorage<DebugInfoReadoutItem[]>(
  CAROUSEL_DEBUG_READOUT_STORAGE_KEY,
  []
);

carouselDebugReadoutAtom.debugLabel = 'carouselDebugReadoutAtom';
